import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import InsertCommentIcon from '@material-ui/icons/InsertComment';
import PropTypes from 'prop-types';
import React from 'react';
import CancelButton from '../CancelButton';
import { globalStyles as styles } from '../style/gstheme';


class AddCommentButton extends React.Component {

    render() {

        const { onClick } = this.props;

        return (
            <div style={{ marginTop: 6 }}>
                <Typography variant="body2" data-test="add-comment">
                    <InsertCommentIcon style={{ verticalAlign: 'middle', marginRight: 6 }} />
                    <CancelButton dataTest="add-discussion-item" onClick={onClick}>Add Comment</CancelButton>
                </Typography>
            </div>
        );
    }
}

AddCommentButton.propTypes = {
    classes: PropTypes.object,
    onClick: PropTypes.func.isRequired
};

export default withStyles(styles)(AddCommentButton);